/* global axios */
import ApiClient from '../ApiClient';

class MercadolibreChannel extends ApiClient {
  constructor() {
    super('mercadolibre', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }

  getConfiguration() {
    return axios.get(`${this.url}/configuration`);
  }

  updateConfiguration(payload) {
    return axios.patch(`${this.url}/configuration`, payload);
  }
}

export default new MercadolibreChannel();
